import { useCallback } from 'react';
import { apiGetUserAccessTokens } from 'src/utils/journeyApi';

export type Provider = 'google-drive' | 'gong' | 'microsoft-one-drive';
export type Token = {
  id: number;
  access_token: string;
  email: string;
  provider: string;
  data?: unknown;
  expires_at: number;
};

type ApiIntegrationsHookReturnType = {
  fetchAccessTokens: (provider: Provider) => Promise<Token[]>;
};

export const useApiIntegrations = (): ApiIntegrationsHookReturnType => {
  const fetchAccessTokens = useCallback(async (provider: Provider) => {
    const response = await apiGetUserAccessTokens(provider);
    return response.tokens as Token[];
  }, []);

  return { fetchAccessTokens };
};
